module.exports = __webpack_public_path__ + "img/qiye2.25915486.png";